export default "__VITE_ASSET__C3Ub9QpC__"